<template>
  <div class="flex flex-col gap-4">
    <div>
      <!-- <div class="flex justify-center max-w-xl mx-auto" dir="ltr">
        <VueDatePicker
          auto-apply
          :day-names="['ن', 'ث', 'ر', 'خ', 'ج', 'س', 'ح']"
          locale="ar"
          :ui="{
            input: 'text-primary text-3xl font-bold text-center',
            navBtnNext: ' rtl:rotate-180 rtl:transform rtl:text-right',
            navBtnPrev: ' rtl:rotate-180 rtl:transform rtl:text-right'
          }"
          placeholder="اختر نطاق التقرير"
          range
          select-text="اختر"
          cancel-text="الغاء"
          v-model="range"
          :preview-format="
            (date: Date[]) =>
              `من ${moment(date?.[0]).format('YYYY-MM-DD')} إلى ${moment(date?.[1]).format('YYYY-MM-DD')}`
          "
          :format="
            (date: Date[]) =>
              `من ${moment(date?.[0]).format('YYYY-MM-DD')} إلى ${moment(date?.[1]).format('YYYY-MM-DD')}`
          "
          :enable-time-picker="false"
          :time-picker="false"
          focus-start-date
          :max-date="new Date()"
        >
        </VueDatePicker>
      </div> -->
    </div>
    <div class="sm:p-4">
      <!-- <canvas class="" id="chart" ref="canvas"></canvas> -->

      <div class="flex justify-between gap-2 flex-wrap sm:flex-nowrap">
        <div class="flex flex-col gap-2 border dark:border-gray-700 rounded-lg p-3 items-center w-full dark:text-gray-200">
          <div>عدد الأوجه المحفوظة</div>
          <div class="text-green-500">{{ data[1].toFixed(1) }}</div>
        </div>

        <div class="flex flex-col gap-2 border dark:border-gray-700 rounded-lg p-3 items-center w-full dark:text-gray-200">
          <div>عدد الأوجه المراجعة</div>
          <div class="text-blue-500">{{ data[0].toFixed(1) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Evaluation, Plan, Session, Student } from '@/types/global'
import { computed, onMounted, ref, toRefs, watch } from 'vue'
import Chart from 'chart.js/auto'
import moment from 'moment'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { useQuery } from '@tanstack/vue-query'
import { getRangeEvaluations } from '@/services/evaluations'
import { fetchStudentPlan } from '@/services/plans'
import { useSelectedSessionId } from '@/composables/useSelectedSessionId'
import { fetchSessions } from '@/services/sessions'

// const range = ref([moment().subtract(7, 'days').toDate(), moment().toDate()])
const canvas = ref<HTMLCanvasElement | null>(null)

const props = defineProps<{
  evaluations : Evaluation[]
}>()

const { evaluations } = toRefs(props)

let chart: Chart | undefined

// const selectedSessionId = useSelectedSessionId()

// const { data: sessions } = useQuery({
//   queryKey: ['sessions', 'evaluations'],
//   queryFn: async () => await fetchSessions(['name']),
//   select(data) {
//     if (selectedSessionId.value == -2) {
//       selectedSessionId.value = data[0].id
//     }

//     return data
//   }
// })

// const { data: evaluations, refetch: refetchEvaluations } = useQuery({
//   queryKey: ['evaluations', range],
//   queryFn: async () => {
//     return await getRangeEvaluations(
//       moment(range.value?.[0]).format('YYYY-MM-DD'),
//       moment(range.value?.[1]).format('YYYY-MM-DD'),
//       [['session_id', 'in', props.sessionsIds]],
//       ['total_review_page', 'total_memorize_page', 'date']
//     )
//   }
// })

// const { data: plans } = useQuery({
//   queryKey: ['plans'],
//   queryFn: async () => {
//     const plans: Plan[] = []

//     for (const student of props.students ?? []) {
//       const plan = await fetchStudentPlan(student?.current_plan_id.id as number)
//       plans.push(plan)
//     }

//     return plans
//   },
//   enabled: computed(() => !!props.students)
// })

const data = computed(() => {
  let review = 0
  let memorize = 0

  evaluations.value?.forEach((evaluation) => {
    review += evaluation.total_review_page ?? 0
    memorize += evaluation.total_memorize_page ?? 0
  })

  return [review, memorize]
})

watch(data, (value) => {
  if (chart) {
    chart.data.datasets[0].data = value
    chart.update()
  }
})
onMounted(() => {})
</script>

<style scoped></style>
